import type { Step } from "react-joyride";

export const leaveEntitlementCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າສ້າງສິດລາຕໍ່ປີໃໝ່. ເລືອກພະນັກງານ, ປະເພດລາ, ປີ ແລະ ຈຳນວນວັນ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-entitlement-create-back"]',
    content: "ກັບຄືນສູ່ຫນ້າສິດລາຕໍ່ປີ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-entitlement-create-form"]',
    content: "ຟອມສິດລາ. ຕື່ມຄົບແລ້ວບັນທຶກ.",
    placement: "top",
  },
];
